import { ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideNativeDateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { NgxMaskConfig, provideEnvironmentNgxMask, provideNgxMask } from 'ngx-mask';
import * as Sentry from '@sentry/angular';
import { routes } from './app.routes';
import { AUTH_PROVIDERS } from './core/auth/auth.providers';
import { authInterceptor } from './core/auth/auth.interceptor';
import { SentryErrorHandler } from './core/sentry/sentry-error.handler';

const maskConfig: Partial<NgxMaskConfig> = {
  prefix: '+',
};

const RU_DATE_FORMATS = {
  parse: { dateInput: 'dd.MM.yyyy' },
  display: {
    dateInput: 'dd.MM.yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'dd.MM.yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'ru-RU' },
    { provide: MAT_DATE_FORMATS, useValue: RU_DATE_FORMATS },
    provideEnvironmentNgxMask(maskConfig),
    provideNgxMask({
      dropSpecialCharacters: true,
      showMaskTyped: false,
    }),
    { provide: ErrorHandler, useClass: SentryErrorHandler },
    Sentry.TraceService,
    ...AUTH_PROVIDERS,
  ],
};
